import { FormItemProps } from 'components/Form/FormItem';
import { Fragment, VFC } from 'react';
import { ThermalMeterDetailField } from './constants';
import { AdditionalThermalDetails, getThermalDetailFormItem } from './utils/getDetailFormItem';

interface ThermalDetailsProps {
  itemsConfig: Partial<
    Record<
      ThermalMeterDetailField,
      {
        formItemProps?: FormItemProps;
        additionalConfig?: AdditionalThermalDetails;
      }
    >
  >;
}

export const ThermalDetails: VFC<ThermalDetailsProps> = ({ itemsConfig }) => {
  return (
    <>
      {Object.entries(itemsConfig).map(([item, { additionalConfig = {}, formItemProps = {} }]) => (
        <Fragment key={item}>
          {getThermalDetailFormItem(item as ThermalMeterDetailField, formItemProps, additionalConfig)}
        </Fragment>
      ))}
    </>
  );
};
